<template>
  <div v-if="!isMobile" class="flex">
    <div v-if="isLoggedIn" class="flex w-full items-center justify-start">
      <div v-if="isPlayed" class="flex justify-between items-center w-full text-white">
        <div class="u-center mr-6">
          <p v-if="type === 'leaderboard'" class="border rounded-md u-center py-2 px-[7px] mr-2 w-[50px] h-[34px]">{{ player.rank }}.</p>
          <OImage :key="user.username" loading="lazy" :src="userImg" class="mr-2 w-[45px] h-[45px] rounded-[100px] object-cover" />
          <p>{{ user.username }}</p>
        </div>
        <div class="u-center">
          <p class="text-[#F7F8FB] text-xl text-right font-extrabold mr-1.5">{{ player.score }}</p>
          <OIcon icon="onedioPuan" />
        </div>
        <OButton
          v-if="type === 'skor'"
          pure
          class="u-center h-8 px-2 mr-0.5 ml-4 siralama-bg text-13 font-semibold leading-22"
          :href="`${isWebview ? '/mobile' : ''}/oyun/leaderboard/${currentTab}`"
          :style="{ boxShadow: `inset 0 100vw  #${currentTab === 'emojile' ? '182F73' : '6024A8'}` }"
        >
          <OIcon icon="mobile-leaderboard-icon" svg-class="h-6 w-[17px]" class="text-white" />
          Sıralamalar
        </OButton>
      </div>
      <div v-else class="flex flex-row items-center">
        <OImage :key="user.username" loading="lazy" :src="userImg" class="mr-2 w-[45px] h-[45px] rounded-[100px] object-cover" />
        <p class="font-medium text-white ml-2">
          Haydi {{ user.username }},
          <span class="font-bold">puanını ve sıralamanı belirle!</span>
        </p>
      </div>
    </div>
    <div v-else class="flex flex-row u-center cursor-pointer" @click="handleLoginModal">
      <OImage :key="1" loading="lazy" src="/images/game/defaultPP.png" class="mr-2" />
      <div class="flex flex-col text-md text-white">
        <p class="font-medium">Onedio Üyesi Ol,</p>
        <p class="font-bold">Sen de sıralamalarda yerini al!</p>
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex items-center justify-between h-[69px] w-full px-6 py-3"
    :class="{ bilpopHeader: currentTab === 'bilpop', emojileHeader: currentTab === 'emojile' }"
  >
    <div v-if="isLoggedIn" class="flex w-full items-center justify-start">
      <div v-if="isPlayed" class="flex justify-between w-full text-white">
        <div class="u-center space-x-2">
          <OImage :key="user.username" loading="lazy" :src="userImg" class="w-[45px] h-[45px] rounded-[100px] object-cover" />
          <p class="truncate max-w-24">{{ user.username }}</p>
          <OIcon icon="onedioPuan" />
          <p class="text-white text-xl text-right font-extrabold">{{ player.score }}</p>
        </div>
      </div>
      <div v-else class="flex flex-row items-center justify-start">
        <div class="">
          <OImage :key="user.username" loading="lazy" :src="userImg" class="mr-2 w-[45px] h-[45px] rounded-[100px] object-cover" />
        </div>
        <div class="flex text-md text-white">
          <div class="font-medium">
            <p class="truncate max-w-[150px]">Haydi {{ user.username }},</p>
            <p class="font-bold">puanını ve sıralamanı belirle!</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-row u-center cursor-pointer" @click="handleLoginModal">
      <OImage :key="1" loading="lazy" src="/images/game/defaultPP.png" class="mr-2" />
      <div class="flex flex-col text-md text-white">
        <p class="font-medium">Onedio üyesi ol,</p>
        <p class="font-bold">sen de sıralamalarda yerini al</p>
      </div>
    </div>
    <div class="siralama-bg">
      <OButton
        pure
        class="u-center h-8 px-2 mr-0.5 text-13 text-[#161616] font-semibold leading-22"
        :href="`${isWebview ? '/mobile' : ''}/oyun/leaderboard/${currentTab}`"
      >
        <OIcon icon="mobile-leaderboard-icon" svg-class="h-6 w-[17px]" class="text-[#161616]" />
        Sıralamalar
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, useAsync, useContext, ssrRef } from '@nuxtjs/composition-api';
import { OButton, OImage, OIcon } from '~/modules/common/components/ui';
import { IS_ONEDIO } from '~/constants/config';
import { useAuth } from '~/modules/auth/state/useAuth';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { useDevice } from '~/composables/useDevice';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  props: {
    currentTab: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    isWebview: {
      type: Boolean,
      default: false,
    },
  },
  components: { OButton, OImage, OIcon },
  setup(props) {
    const { user, isLoggedIn } = useAuth();
    const { $service } = useContext();
    const { isMobile } = useDevice();
    const userImg = getImageUrl(user.value?.avatar);
    const isPlayed = computed(() => {
      return player.value.rank !== null;
    });
    const player = ssrRef({});
    const getPlayerRank = async () => {
      try {
        const userParams = {
          boardType: props.currentTab,
          duration: 'yearly',
          playerId: user.value?._id,
        };
        const { data } = await $service.game.getPlayerRank(userParams);
        player.value = data;
      } catch (err) {
        console.log(err);
      }
    };
    const { openLoginModal } = useModal();
    const handleLoginModal = async () => {
      await openLoginModal();
    };
    useAsync(async () => {
      if (isLoggedIn.value) {
        await getPlayerRank();
      }
    });

    return { IS_ONEDIO, user, isLoggedIn, userImg, isPlayed, player, isMobile, handleLoginModal };
  },
});
</script>

<style lang="scss" scoped>
.siralama-bg {
  border-radius: 4px;
  background-image: linear-gradient(to left, #9db558, #5d8e9d, #432c9d);
  background-origin: border-box;
  box-shadow: inset 0 100vw white;
  border: 2px solid transparent;
}
img {
  flex-shrink: 0;
}
.bilpopHeader {
  background: linear-gradient(166deg, #400677 -6.27%, #6e2fbf 106.87%);
}
.emojileHeader {
  background: linear-gradient(166deg, #00084d -6.27%, #2c4389 106.87%);
}
</style>
